import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { dlPush } from './analytics';

export default function PageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        dlPush({
            event: 'page_view',
            page_path: location.pathname + location.search,
            page_title: document.title
        });
    }, [location.pathname, location.search]);

    return null;
}
